import React from "react";
import { View, Text, Image, StyleSheet } from "react-native";
import { AppColors } from "../../../../../../utility/AppColors";
import { AppFontStyle } from "../../../../../../styles/AppFontStyle";
import { AppImages } from "../../../../../../utility/AppImages";

const CompactPoll: React.FC = () => {
  const youProgress = 60;
  const nameProgress = 45;
  const staticName = "PlayerXYZ";
  const votes = "1256";
  const remainingTime = "2:15";

  const topGiftersData = [
    { id: "1", name: "User1", gifts: 100 },
    { id: "2", name: "User2", gifts: 75 },
    { id: "3", name: "User3", gifts: 50 },
    { id: "4", name: "User4", gifts: 40 },
  ];

  return (
    <View
      style={{
        flexDirection: "row",
        height: "100%",
        overflow: "hidden",
        padding: 8,
      }}
    >
      {/* Audience Poll Section */}
      <View
        style={{
          flex: 1,
          backgroundColor: AppColors.grayColor_282828,
          borderTopLeftRadius: 8,
          borderBottomLeftRadius: 8,
        }}
      >
        <View style={{ padding: 4, flex: 1 }}>
          <Text
            style={[
              AppFontStyle.BOLD_ANYBODY_8,
              { color: AppColors.purple_C084FC, marginBottom: 2 },
            ]}
          >
            Audience Poll
          </Text>

          <Text style={{ color: "#1E90FF", fontSize: 7, marginBottom: 1 }}>
            You
          </Text>
          <View
            style={{
              width: "100%",
              height: 4,
              backgroundColor: "#2D3748",
              borderRadius: 2,
              marginBottom: 1,
            }}
          >
            <View
              style={{
                width: `${youProgress}%`,
                height: "100%",
                backgroundColor: "#1E90FF",
                borderRadius: 2,
              }}
            />
          </View>
          <Text
            style={{
              color: "#9CA3AF",
              fontSize: 6,
              textAlign: "right",
              marginBottom: 2,
            }}
          >
            {youProgress}%
          </Text>

          <Text style={{ color: "#FF0000", fontSize: 7, marginBottom: 1 }}>
            {staticName}
          </Text>
          <View
            style={{
              width: "100%",
              height: 4,
              backgroundColor: "#2D3748",
              borderRadius: 2,
              marginBottom: 1,
            }}
          >
            <View
              style={{
                width: `${nameProgress}%`,
                height: "100%",
                backgroundColor: "#FF0000",
                borderRadius: 2,
              }}
            />
          </View>
          <Text
            style={{
              color: "#9CA3AF",
              fontSize: 6,
              textAlign: "right",
              marginBottom: 2,
            }}
          >
            {nameProgress}%
          </Text>

          <View
            style={{ flexDirection: "row", justifyContent: "center", gap: 2 }}
          >
            <Text style={{ color: AppColors.white, fontSize: 6 }}>
              {votes} votes
            </Text>
            <Text style={{ color: AppColors.white, fontSize: 6 }}>
              {remainingTime} remaining
            </Text>
          </View>
        </View>
      </View>

      {/* Top Gifters Section */}
      <View
        style={{
          flex: 1,
          backgroundColor: AppColors.grayColor_282828,
          borderTopRightRadius: 8,
          borderBottomRightRadius: 8,
        }}
      >
        <View style={{ padding: 4, flex: 1 }}>
          <Text
            style={[
              AppFontStyle.BOLD_ANYBODY_8,
              { color: AppColors.purple_C084FC, marginBottom: 2 },
            ]}
          >
            Top Gifters
          </Text>

          <View
            style={{
              flex: 1,
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "space-between",
            }}
          >
            {topGiftersData.slice(0, 4).map((item) => (
              <View
                key={item.id}
                style={{
                  width: "48%",
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: 2,
                }}
              >
                <View style={{ position: "relative", marginRight: 3 }}>
                  <Image
                    source={AppImages.Ellipse1}
                    style={{ width: 12, height: 12, borderRadius: 6 }}
                  />
                  <View
                    style={{
                      position: "absolute",
                      top: -1,
                      right: -1,
                      backgroundColor: AppColors.purple_6D28D9,
                      borderRadius: 4,
                      width: 8,
                      height: 8,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Text style={{ color: "white", fontSize: 4 }}>
                      {item.gifts}
                    </Text>
                  </View>
                </View>
                <View style={{ flex: 1 }}>
                  <Text
                    style={{ color: "white", fontSize: 6 }}
                    numberOfLines={1}
                  >
                    {item.name}
                  </Text>
                  <Text style={{ color: "#9CA3AF", fontSize: 5 }}>
                    {item.gifts} gifts
                  </Text>
                </View>
              </View>
            ))}
          </View>
        </View>
      </View>

      {/* Coming Soon Overlay */}
      <View
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: 12,
        }}
      >
        <Text
          style={{
            color: "white",
            fontSize: 12,
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          Audience Poll & Top Gifter
        </Text>
        <Text style={styles.comingSoonText}>Coming Soon</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  comingSoonText: {
    color: "#FACC15",
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center",
    marginTop: 4,
  },
});

export default CompactPoll;
